<template>
  <ScheduleControlRow
    title="Unassigned"
    :summary="summary"
    @select="emit('select')"
    @settings="emit('settings')"
  >
    <template #avatar>
      <UnassignedAvatar />
    </template>
  </ScheduleControlRow>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { pluralize } from "@/mixins";
import ScheduleControlRow from "./ScheduleControlRow.vue";
import { summaryPeriodLabel } from "./summaryPeriod";
import UnassignedAvatar from "./UnassignedAvatar.vue";

const props = defineProps<{
  appointmentCount: number;
  date: Date;
  weekView?: boolean;
}>();

const emit = defineEmits<{
  (e: "select"): void;
  (e: "settings"): void;
}>();

const summary = computed(
  () =>
    `${props.appointmentCount} ${pluralize(props.appointmentCount, "appointment")} needing a technician · ${summaryPeriodLabel(props.date, { weekView: props.weekView })}`
);
</script>
